<template>
  <div>
    <list-container title="Actions" :items='items' :filterable-tags="filterableTags">
      <template v-slot:default="slotProps">
        <div class='details clearfix'>
          <div class="stats">
            <div>
              <h3 v-html="colorize(slotProps.item.get('name'))"></h3>
            </div>

            <div v-if="slotProps.item.get('trigger')">
              <p><b>Trigger:</b> <span v-html="colorize(slotProps.item.get('trigger'))"></span></p>
            </div>

            <div v-if="slotProps.item.get('requirements').length > 0">
              <b>Requirements</b>
              <ul>
                <li v-for="requirement in slotProps.item.get('requirements')" v-html="colorize(requirement)"></li>
              </ul>
            </div>
          </div>

          <div class="effects">
            <div class="action-info">
              <p v-html="colorize(slotProps.item.get('effects'))"></p>

              <div v-if='slotProps.item.outcomes().length > 0' class="detail-section">
                <outcomes :outcomes="outcomesFor(slotProps.item)"></outcomes>
              </div>
            </div>

            <div v-if='slotProps.item.hazards().length > 0' class='action-info'>
              <div class="detail-section">
                <div class="body">
                  <hazards :hazards="slotProps.item.hazards()"></hazards>
                </div>
              </div>
            </div>

            <div v-if='slotProps.item.actions().length > 0'>
              <div v-for='action in slotProps.item.actions()' class='action-info'>
                <p><span class="game-action">Action</span> <b v-html="colorize(action.get('name'))"></b>: <span v-html="colorize(action.get('effects'))"></span></p>

                <div v-if='action.get("requirements").length > 0'>
                  <div class="body">
                    <ul>
                      <li v-for="requirement in action.get('requirements')" v-html="colorize(requirement)"></li>
                    </ul>
                  </div>
                </div>

                <div v-if='outcomesFor(action).length > 0' class="detail-section">
                  <div class="body">
                    <outcomes :outcomes="outcomesFor(action)"></outcomes>
                  </div>
                </div>

                <div v-if='obstaclesFor(action).length > 0' class="detail-section">
                  <div class="body">
                    <p>Obstacles</p>
                    <obstacles :obstacles="obstaclesFor(action)"></obstacles>
                  </div>
                </div>

                <div v-if='hazardsFor(action).length > 0' class="detail-section">
                  <div class="body">
                    <hazards :hazards="hazardsFor(action)"></hazards>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </template>
    </list-container>
  </div>
</template>

<script>
  import actionCollection from './collection.js';
  import ListContainer from '../shared/list-container.vue';
  import Outcomes from '../shared/outcomes.vue';
  import Obstacles from '../shared/obstacles.vue';
  import Hazards from '../shared/hazards.vue';
  import colorizeKeywords from '../shared/colorize.js';

  import { compact, join, sortBy, startCase } from 'lodash';

  export default {
    name: 'actions-app',

    components: { ListContainer, Outcomes, Obstacles, Hazards },

    data: function(){
      return {
        collection: new actionCollection(),
        items: [],
        filterableTags: []
      }
    },

    beforeMount() {
      const comp = this;

      this.collection.fetch().then(() => {
        this.items = comp.collection.alphabetical();
        this.filterableTags = this.collection.tags().sort();
      });
    },

    methods: {
      outcomesFor(item) {
        return sortBy(item.outcomes(), 'cost');
      },

      actionTypeLine(action) {
        const types = [
          startCase(action.get('action_type')),
          startCase(action.get('action_sub_type'))
        ];


        return join(compact(types), ' - ');
      },

      obstaclesFor(item) {
        return sortBy(item.obstacles(), 'cost');
      },

      hazardsFor(item) {
        return sortBy(item.hazards(), 'cost');
      },

      colorize(text) { return colorizeKeywords(text); }
    }
  }
</script>
